import { LoadingOutlined } from '@ant-design/icons';
import { observer } from 'mobx-react';
import React from 'react';
import styled, { css } from 'styled-components';

import store from 'stores/RootStore';
import { AnimationPanelViews } from 'types/AnimationPanelViews';

import AnimationStageFrame from './AnimationStageFrame';
import EmptyPlaceholder from './EmptyPlaceHolder';
import PlayerControls from './PlayerControls';

interface ContainerProps {
  $showBorder?: boolean;
  $backgroundColor?: string;
  $showCheckerboard?: boolean;
}

const CHECKERBOARD = css`
  background-image:
    linear-gradient(45deg, #ccc 25%, transparent 25%),
    linear-gradient(-45deg, #ccc 25%, transparent 25%),
    linear-gradient(45deg, transparent 75%, #ccc 75%),
    linear-gradient(-45deg, transparent 75%, #ccc 75%);
  background-size: 20px 20px;
  background-position:
    0 0,
    0 10px,
    10px -10px,
    -10px 0;
`;

// $showBorder not actually used?
const Container = styled.div<ContainerProps>`
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-width: 0;
  height: 100%;
  justify-content: center;
  align-items: center;

  background-color: ${(p) =>
    p.$backgroundColor && !p.$showCheckerboard
      ? p.$backgroundColor
      : 'transparent'};

  ${(p) => (p.$showCheckerboard ? CHECKERBOARD : '')}
`;

const LoadingIcon = styled(LoadingOutlined)`
  font-size: 40px;
`;

function AnimationStage() {
  const store_animation = store.animation;

  const animationURL = store_animation?.currentAnimationAsset?.downloadURL;
  const loading = store_animation ? !store_animation.assets.loaded : false;

  const handleFileSelected = async (file: File) => {
    if (store_animation) {
      store_animation.setPanel(AnimationPanelViews.VERSIONS);
      await store_animation.uploadAnimationFile(file);
    }
  };

  return (
    <Container
      $showBorder={store_animation?.showBorder}
      $backgroundColor={store_animation?.backgroundColor}
      $showCheckerboard={store_animation?.showCheckerboard}
    >
      {loading ? (
        <LoadingIcon />
      ) : animationURL ? (
        <>
          <AnimationStageFrame />
          <PlayerControls
            player={store_animation.player}
            loaded={store_animation.assets.loaded}
          />
        </>
      ) : (
        <EmptyPlaceholder onFileSelected={handleFileSelected} />
      )}
    </Container>
  );
}

export default observer(AnimationStage);
